import React from "react";
import PropTypes from "prop-types";
import ModalDialog from "@cx/ui/ModalDialog";
import Button from "@cx/ui/Button";
import { useTranslation } from "react-i18next";
import "./_accountMergeModal.scss";

const AccountMergeModal = ({ show, onCancel, onContinue }) => {
  const { t } = useTranslation();

  return (
    <ModalDialog
      htmlId="account-merge-modal"
      show={show}
      displayCloseButton={false}
      className="account-merge-modal"
    >
      <div className="account-merge-modal-content">
        <h3>{t("merge-modal.title")}</h3>

        <p className="merge-modal-description">
          {t("merge-modal.description")}
        </p>

        <div className="merge-modal-info-section">
          <h4>{t("merge-modal.what-happens-title")}</h4>
          <ul className="merge-modal-list">
            <li>{t("merge-modal.solutions-combined")}</li>
            <li>{t("merge-modal.second-account-deactivated")}</li>
            <li>{t("merge-modal.keep-current-login")}</li>
          </ul>
        </div>

        <div className="merge-modal-actions">
          <Button
            htmlId="merge-modal-cancel-button"
            buttonStyle="secondary"
            onClick={onCancel}
          >
            {t("common.cancel")}
          </Button>
          <Button
            htmlId="merge-modal-continue-button"
            buttonStyle="primary"
            onClick={onContinue}
          >
            {t("merge-modal.continue-button")}
          </Button>
        </div>
      </div>
    </ModalDialog>
  );
};

AccountMergeModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
};

export default AccountMergeModal;
